export const representationOptions = [
  {
    value: '1',
    label: 'Defensa pública (gratuita)',
    id: 'check_representation_1',
  },
  {
    value: '2',
    label: 'Defensa privada',
    id: 'check_representation_2',
  },
  {
    value: '3',
    label: 'Defensa pública y privada',
    id: 'check_representation_3',
  },
  {
    value: '4',
    label: 'Representación social',
    id: 'check_representation_4',
  },
  {
    value: '5',
    label: 'No contaron con representación legal',
    id: 'check_representation_5',
  },
  {
    value: '6',
    label: 'No identificado',
    id: 'check_representation_6',
  },
];
